import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { FormControlLabel } from '@material-ui/core';
import { MASKED_PHONE_CHARS, PhoneMaskedTextInput } from 'Components/UI/MaskedInput';

const useStyles = makeStyles(() => ({
  enabledControl: {
    justifyContent: 'flex-end',
    marginLeft: '0px',
  },
  switchLabel: {
    flex: '1 0 0',
  },
}));

export default function Employment({ handleUpdate, client }) {
  const classes = useStyles();
  return (
    <>
      <FormControlLabel
        control={
          <MetaControl
            attrName="isEmployed"
            onChange={value => handleUpdate(client.attr('isEmployed', value))
            }
            resource={client}
          />
        }
        label={client
          .meta()
          .field('isEmployed')
          .attr('prompt')}
        labelPlacement="start"
        classes={{
          root: classes.enabledControl,
          label: classes.switchLabel,
        }}
      />
      <MetaControl
        attrName="employerName"
        onChange={value => handleUpdate(client.attr('employerName', value))
        }
        resource={client}
      />
      <MetaControl
        attrName="jobTitle"
        onChange={value => handleUpdate(client.attr('jobTitle', value))}
        resource={client}
      />
      <MetaControl
        attrName="employerAddress1"
        onChange={value => handleUpdate(client.attr('employerAddress1', value))}
        resource={client}
      />
      <MetaControl
        attrName="employerAddress2"
        onChange={value => handleUpdate(client.attr('employerAddress2', value))}
        resource={client}
      />
      <MetaControl
        attrName="employerCity"
        onChange={value => handleUpdate(client.attr('employerCity', value))}
        resource={client}
      />
      <MetaControl
        attrName="employerState"
        onChange={value => handleUpdate(client.attr('employerState', value))}
        resource={client}
      />
      <MetaControl
        attrName="employerZip"
        onChange={value => handleUpdate(client.attr('employerZip', value))}
        resource={client}
      />
      <MetaControl
        attrName="employerOfficeNumber"
        onChange={(value) => {
          handleUpdate(client.attr('employerOfficeNumber', value.replace(MASKED_PHONE_CHARS, '')));
        }}
        InputProps={{
          inputComponent: PhoneMaskedTextInput,
        }}
        resource={client}
      />
      <FormControlLabel
        control={
          <MetaControl
            attrName="isConsideringJobChange"
            onChange={value => handleUpdate(
              client.attr('isConsideringJobChange', value),
            )
            }
            resource={client}
          />
        }
        label={client
          .meta()
          .field('isConsideringJobChange')
          .attr('prompt')}
        labelPlacement="start"
        classes={{
          root: classes.enabledControl,
          label: classes.switchLabel,
        }}
      />
    </>
  );
}

Employment.propTypes = {
  handleUpdate: PropTypes.func.isRequired,
  client: PropTypes.object.isRequired,
};
